/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const LaptopMinimalCheck = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M2 20h20" }],
    ["path", { d: "m9 10 2 2 4-4" }],
    ["rect", { x: "3", y: "4", width: "18", height: "12", rx: "2" }]
  ]
];

export { LaptopMinimalCheck as default };
//# sourceMappingURL=laptop-minimal-check.js.map
